const faqData = [
  {
    question: "How can I add your AI-based chatbot to my website?",
    answer:
      "Adding Jaano to your website is simple and requires just three steps:<br>\n    ● Register on our platform.<br>\n    ● Customize Jaano to align with your website’s style and business requirements.<br>\n    ● Deploy the provided code snippet on your website.<br><br>\n    Our user-friendly process ensures quick integration without technical complexity.",
  },
  {
    question: "How does Jaano improve conversions?",
    answer:
      "Jaano enhances your website’s conversion rates by offering instant responses, guiding visitors, and addressing their queries 24/7. By engaging users effectively, Jaano helps reduce bounce rates and encourages actions such as making a purchase, signing up, or booking a service.",
  },
  {
    question: "Can Jaano handle multiple conversations simultaneously?",
    answer:
      "Absolutely! Jaano is designed to manage unlimited concurrent conversations efficiently. Whether you have a handful of visitors or hundreds interacting at once, Jaano ensures smooth, responsive engagement without delays.",
  },
  {
    question: "What benefits can I expect after installing Jaano?",
    answer:
      "After installing Jaano, you can expect:<br>\n    ● Improved customer engagement and conversions.<br>\n    ● Reduced operational costs by automating routine inquiries.<br>\n    ● Enhanced lead generation with effective data collection.<br>\n    ● Increased conversions through proactive visitor interaction.<br>\n    ● 24/7 availability to ensure no customer inquiry goes unanswered.",
  },
  {
    question: "Is your chatbot free?",
    answer:
      "We offer a free trial for Jaano, allowing you to experience its features before committing. After the trial period, you can choose from our flexible pricing plans tailored to different business needs.",
  },
  {
    question: "How much does it cost to add a chatbot to my website?",
    answer:
      "Our pricing is designed to be affordable for businesses of all sizes. We can also provide customized plans based on your website’s requirements, ensuring you get the best value for your investment. Contact us for detailed pricing information.",
  },
  {
    question: "Is my website compatible with your chatbot?",
    answer:
      "Yes, Jaano is designed to integrate seamlessly with all types of websites, including WordPress, Shopify, Wix, Squarespace, and custom-built platforms.",
  },
  {
    question: "How does your AI chatbot work?",
    answer:
      "Jaano uses advanced natural language processing (NLP) and machine learning algorithms to understand visitor queries, provide relevant responses, and improve over time. It can handle common questions, guide users through processes, and even capture leads.",
  },
  {
    question:
      "How secure is your AI chatbot application in handling customer data?",
    answer:
      "We prioritize data security with robust encryption protocols and compliance with industry standards. Jaano ensures that all user interactions and sensitive data are handled securely to protect your business and customers.",
  },
  {
    question: "Do you offer a free trial?",
    answer:
      "Yes, we offer a risk-free trial that includes up to 50 message replies, allowing you to explore Jaano's capabilities and experience how it enhances your website’s performance before making a commitment.",
  },
  {
    question: "What technical skills are required to set up Jaano?",
    answer:
      "Minimal technical knowledge is required. Our installation process is straightforward, and we provide clear instructions to help you add Jaano to your website effortlessly. Our support team is also available to assist you throughout the setup.",
  },
  {
    question:
      "Can I customize Jaano's responses and behavior after installation?",
    answer:
      "Yes! Jaano offers extensive customization options, allowing you to tailor responses, conversation flow, and chatbot behavior to match your business goals and customer preferences.",
  },
  {
    question: "What are the pricing plans for Jaano's AI chatbot?",
    answer:
      "We offer two flexible pricing plans to suit different business needs:<br>\n    ● <b>Standard Plan – $25 per month:</b> Ideal for small businesses or websites with moderate traffic. This plan includes essential chatbot features to handle customer inquiries efficiently.<br>\n    ● <b>Professional Plan – $99 per month:</b> Designed for larger businesses or websites with higher traffic. This plan offers advanced features, enhanced customization options, and improved performance for managing complex interactions.",
  },
  {
    question: "What kind of support do you offer during and after setup?",
    answer:
      "We provide comprehensive support to ensure a smooth experience. Our dedicated team is available via call and message to assist you during installation, troubleshoot issues, and guide you in optimizing Jaano for maximum performance.",
  },
];

export default faqData;
